module.exports = "/_next/static/images/img__card-5-desktop-19f51ee17673a4a8b7bcd94a90fbdadb.png";